import { DefaultRootState, useSelector } from "react-redux";
import { editRowPLACEHOLDER } from "../../requests/tableRowActions/placeholderData";
import {
  getAvailableDetailTemplates,
  getDataTemplateSlice,
  getEditRowIsFetchingById,
  getEmptyDataTableItem,
  getIsFetchingTemplateBuilderById,
  getPossibleDetailTemplates,
  getPossibleHegClasses,
  getPossibleHegFolders,
  getPossibleItemTemplatesSlice,
  getPossibleOverviewTemplates,
  getPresentationTemplateSlice,
  getSqlQueryForId,
  getSqlQueryIsFetching,
  getStateChangedForId,
  getTables,
  getTemplateBuilderById,
  getTemplateBuilderDataForId,
  getTemplateBuilderEditRowForId,
  getTemplateBuilderInvalidatedDatasetsForId,
  getTemplateBuilderNameFromEditRowById,
} from "./selectors";

export const useIsTemplateBuilderFetching = (templateBuilderId: number) =>
  useSelector((state: DefaultRootState) => {
    const isModelFetching = getIsFetchingTemplateBuilderById(
      state,
      templateBuilderId
    );
    const isEditRowFetching = getEditRowIsFetchingById(
      state,
      templateBuilderId
    );
    const isSqlQueryFetching = getSqlQueryIsFetching(state, templateBuilderId);

    return isModelFetching || isEditRowFetching || isSqlQueryFetching;
  });

export const useTemplateBuilderInvalidatedDatasets = (tId: number) =>
  useSelector((s) => getTemplateBuilderInvalidatedDatasetsForId(s, tId));

export const useIsTemplateBuilderLoaded = (templateBuilderId: number) => {
  const templateBuilderData = useSelector((state) =>
    getTemplateBuilderById(state, templateBuilderId)
  );
  return !!templateBuilderData?.model?.data;
};

export const useStateChanged = (templateBuilderId: number) =>
  useSelector((state) => getStateChangedForId(state, templateBuilderId));

export const useDataTemplateData = (templateBuilderId: number) =>
  useSelector((state) => getDataTemplateSlice(state, templateBuilderId));

export const useEditRowData = (templateBuilderId: number) =>
  useSelector((state) => {
    const data = getTemplateBuilderEditRowForId(state, templateBuilderId);
    return data || editRowPLACEHOLDER;
  });

export const useTemplateBuilderData = (templateBuilderId: number) =>
  useSelector((state) => getTemplateBuilderDataForId(state, templateBuilderId));

export const useTemplateBuilderName = (templateBuilderId: number) => {
  const { templateName = "" } = useTemplateBuilderData(templateBuilderId) ?? {};
  const editRowTemplateName = useSelector((state) =>
    getTemplateBuilderNameFromEditRowById(state, templateBuilderId)
  );
  return editRowTemplateName || templateName;
};

export const usePresentationTemplateData = (templateBuilderId: number) =>
  useSelector((state) =>
    getPresentationTemplateSlice(state, templateBuilderId)
  );

export const usePossibleOverviewTemplates = (templateBuilderId: number) =>
  useSelector((state) =>
    getPossibleOverviewTemplates(state, templateBuilderId)
  );

export const usePossibleDetailTemplates = (templateBuilderId: number) =>
  useSelector((state) => getPossibleDetailTemplates(state, templateBuilderId));

export const usePossibleItemTemplates = (templateBuilderId: number) =>
  useSelector((state) =>
    getPossibleItemTemplatesSlice(state, templateBuilderId)
  );

export const usePossibleHegClasses = (templateBuilderId: number) =>
  useSelector((state) => getPossibleHegClasses(state, templateBuilderId));

export const usePossibleHegFolders = (templateBuilderId: number) =>
  useSelector((state) => getPossibleHegFolders(state, templateBuilderId));

export const useEmptyDataTemplateItem = (templateBuilderId: number) =>
  useSelector((state) => getEmptyDataTableItem(state, templateBuilderId));

export const useAvailableDetailTemplates = (templateBuilderId: number) =>
  useSelector((state) => getAvailableDetailTemplates(state, templateBuilderId));

export const useSqlQueryData = (templateBuilderId: number) =>
  useSelector((state) => getSqlQueryForId(state, templateBuilderId));

export const useTables = (templateBuilderId: number) =>
  useSelector((state) => getTables(state, templateBuilderId));

export const useModuleId = (tbId: number) => {
  const editRow = useEditRowData(tbId);
  const moduleId = editRow.row.cells?.ModuleID?.value ?? -1;
  return Number(moduleId as number | string);
};
